import * as React from "react";
import { connect } from "react-redux";

import { ILine, LineID } from "../api/APIClient";
import { RootState } from "../types";
import { showCreateLine, showEditLine } from "../actions";
import { ShowLineContainer } from "./ShowLineModal";
import moment from "moment";

import "./LinesPage.css";
import { fetchLines } from "src/thunks";
import { rruleToSchedule, RRuleStr, findNextTime } from "src/Schedule";

const WEEKDAY_ABBRS = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];

const formatSchedule = (rrule: RRuleStr): string => {
  const parts: string[] = [];
  for (const entry of rruleToSchedule(rrule)) {
    const nextTime = moment(findNextTime(entry));
    const weekday = WEEKDAY_ABBRS[nextTime.weekday()];
    const time = moment(nextTime).format("hh:mm");
    parts.push(`${weekday} ${time}`);
  }
  return parts.join(",");
};

interface IProps {
  lines: ILine[];

  createLine: () => any;
  editLine: (id: LineID) => any;
  fetchLines: () => any;
}

export class LinesPage extends React.Component<IProps> {
  public componentWillMount() {
    this.props.fetchLines();
  }

  public render() {
    const { lines, createLine } = this.props;

    return (
      <div className="lines-page">
        <ShowLineContainer />

        <div className="header sticky-top">
          <div className="sidebar-right">
            <button
              onClick={createLine}
              type="button"
              className="btn btn-outline-primary"
            >
              New Line
            </button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="user-list table table-sm">
            <thead>
              <tr>
                <th>Line ID</th>
                <th>Operator ID</th>
                <th>Name</th>
                <th>Schedule</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>{lines.map(this.renderRow)}</tbody>
          </table>
        </div>
      </div>
    );
  }

  private renderRow = (line: ILine) => {
    return (
      <tr key={line.id} data-id={line.id} onClick={this.onClickRow}>
        <td className="line-id-row">
          {line.id} {line.private ? "🔒" : null}
        </td>
        <td className="operator-id-row">{line.operatorUsername}</td>
        <td className="line-name-row">{line.name}</td>
        <td>{formatSchedule(line.schedule)}</td>
        <td>{line.description}</td>
      </tr>
    );
  };

  private onClickRow = (e: React.MouseEvent<HTMLElement>) => {
    const { editLine } = this.props;
    const tr = e.currentTarget;
    if (!tr.dataset.id) {
      return;
    }
    const id = tr.dataset.id as LineID;

    editLine(id);
  };
}

export const LinesContainer = connect(
  ({ lines }: RootState) => ({
    lines: lines.data,
  }),
  dispatch => ({
    createLine: () => dispatch(showCreateLine()),
    editLine: (id: LineID) => dispatch(showEditLine(id)),
    fetchLines: () => dispatch<any>(fetchLines()),
  })
)(LinesPage);

export default LinesContainer;



// WEBPACK FOOTER //
// ./src/pages/LinesPage.tsx